import PropTypes from 'prop-types';
import {FmlxIcon, FmlxTooltip} from 'fmlx-common-ui';
import {parseMessage} from '../../../../../lib/stringHelper';
import PipettingProfileInputType from '../PipettingProfileInputType';
import {TaskType} from '../../../../../constants/dataEnum';
import {PipettingProfileItemWrapper} from '../PipettingProfileWrapper';

function PipettingItemEnableMixing({onChange, task, mixingError, errorTooltip}) {
  const {type, enableMixing} = task;

  const labelAspirate = parseMessage('protocolEditor.taskList.pipettingProfile.enableMixingAspirate');
  const labelDispense = parseMessage('protocolEditor.taskList.pipettingProfile.enableMixingDispense');

  const labelEnableMixing = type === TaskType.ASPIRATE ? labelAspirate : labelDispense;

  return (
    <PipettingProfileItemWrapper>
      {labelEnableMixing}
      <PipettingProfileInputType.Switch checked={enableMixing} onChange={(value) => onChange(value, type)} />
      {mixingError ? (
        <FmlxTooltip title={errorTooltip}>
          <span className="info-button">
            <FmlxIcon name="Warning" size="xs" customColor="#FF5252" />
          </span>
        </FmlxTooltip>
      ) : (
        ''
      )}
    </PipettingProfileItemWrapper>
  );
}

PipettingItemEnableMixing.propTypes = {
  onChange: PropTypes.func.isRequired,
  task: PropTypes.string.isRequired,
  mixingError: PropTypes.bool.isRequired,
  errorTooltip: PropTypes.string.isRequired,
};

export default PipettingItemEnableMixing;
